import React, { useEffect, useState, useImperativeHandle } from 'react'
import { Input, Select, message, DatePicker } from 'antd'
import moment from 'moment'
import { getCurrentTime } from '../../../../containers/DemoSystemV2/EventCapsules/utils'
const { TextArea } = Input
const { Search } = Input
const { Option } = Select
const resetImg = require('../../../../assets/reset.png')

const ThirdTpl = props => {
  const {
    tplId,
    cacheTamplateData,
    capsuleDetailInfo,
    templateList,
    isDisabled,
    actionName
  } = props
  const [title, setTitle] = useState('') // 标题
  const [classify, setClassify] = useState(null) // 分类
  const [headLabel, setHeadLabel] = useState(1)
  const [headNumber, setHeadNumber] = useState(0)
  const [complateLabel, setComplateLabel] = useState(1)
  const [complateNumber, setComplateNumber] = useState(0)
  const [info, setInfo] = useState('')
  const [dateTime, setDateTime] = useState(moment(getCurrentTime()))
  const headOption = [
    { label: '抬高', value: 1 },
    { label: '降低', value: 2 }
  ]
  const complateOption = [
    { label: '移入', value: 1 },
    { label: '移出', value: 2 }
  ]

  useEffect(() => {
    // 新建时会产生缓存数据
    const cacheInfo = tplId && cacheTamplateData[tplId] ? cacheTamplateData[tplId] : null
    if (cacheInfo) {
      const jsonContent = cacheInfo.json_content || {}
      cacheInfo.date && setDateTime(moment(cacheInfo.date))
      if (Object.keys(jsonContent).length > 0) {
        jsonContent.classify ? setClassify(jsonContent.classify) : initDefaultClassify()
        setHeadLabel(jsonContent.headLabel)
        setHeadNumber(jsonContent.headNumber)
        setComplateLabel(jsonContent.complateLabel)
        setComplateNumber(jsonContent.complateNumber)
        setInfo(jsonContent.info)
      }
    }
  }, [])

  useEffect(() => {
    const jsonContent = capsuleDetailInfo.jsonContent || {}
    if (Object.keys(jsonContent).length > 0) {
      setDateTime(capsuleDetailInfo.occur_time ? moment(capsuleDetailInfo.occur_time) : '')
      setTitle(jsonContent.title)
      jsonContent.classify
        ? setClassify(jsonContent.classify)
        : capsuleDetailInfo.sn
        ? setClassify(Number(capsuleDetailInfo.sn))
        : initDefaultClassify()
      setHeadLabel(jsonContent.headLabel)
      setHeadNumber(jsonContent.headNumber)
      setComplateLabel(jsonContent.complateLabel)
      setComplateNumber(jsonContent.complateNumber)
      setInfo(jsonContent.info)
    } else {
      initDefaultClassify()
    }
  }, [templateList, isDisabled])

  useImperativeHandle(props.refInstance, () => ({
    checkValidate: checkValidate,
    getTemplatInfo: getTemplatInfo,
    changeTitle: changeTitle,
    changeClassify
  }))

  const changeHeadNumber = newValue => {
    const formatValue = checkNumberValue(newValue)
    if (formatValue !== 'error') {
      setHeadNumber(formatValue)
    }
  }
  const changeComplateNumber = newValue => {
    const formatValue = checkNumberValue(newValue)
    if (formatValue !== 'error') {
      setComplateNumber(formatValue)
    }
  }
  const checkNumberValue = value => {
    const regex = /^\-?(0|[1-9]\d{0,2})?(\.\d{0,2})?$/
    const formatValue = (value || '')
      .replace(/[^\-\d^\.]+/g, '')
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    if (!regex.test(formatValue)) {
      console.log('最多输入3位整数和2位小数', formatValue)
      return 'error'
    }
    return formatValue
  }

  /** 字符串转数字 */
  const formatNumber = (newValue, index) => {
    if (!newValue) return
    const formatValue = isNaN(parseFloat(newValue)) ? '' : parseFloat(newValue)
    index === 1 ? setHeadNumber(formatValue) : setComplateNumber(formatValue)
  }

  /** 设置初始值 */
  const initDefaultClassify = () => {
    if (templateList.length > 0) {
      setClassify(templateList[0].id)
    }
  }

  /** 修改标题 */
  const changeTitle = title => {
    setTitle(title)
  }

  /** 修改分类标签 */
  const changeClassify = id => {
    id && setClassify(id)
  }

  /** 校验表单值是否有效 */
  const checkValidate = () => {
    if (!dateTime) {
      message.error('请选择事件发生时间')
      return false
    }
    if (!(title || '').trim()) {
      message.error('请输入标题')
      return false
    }
    if (!headNumber && headNumber !== 0) {
      message.error(`请输入头部${headLabel === 1 ? '抬高' : '降低'}数值`)
      return false
    }
    if (!complateNumber && complateNumber !== 0) {
      message.error(`请输入整体${complateLabel === 1 ? '移入' : '移出'}数值`)
      return false
    }
    return true
  }

  /** 切换分类 */
  const classifyChange = e => {
    setClassify(e)
  }

  /** 重置 */
  const resetForm = () => {
    setDateTime('')
    setTitle('')
    initDefaultClassify()
    setHeadLabel(null)
    setHeadNumber(null)
    setComplateLabel(null)
    setComplateNumber(null)
    setInfo('')
    const { resetClick: propReset } = props
    propReset()
  }

  /** 获取模版信息 */
  const getTemplatInfo = () => {
    return {
      date: dateTime.format('YYYY-MM-DD HH:mm:00'),
      json_content: {
        title,
        classify,
        headLabel,
        headNumber,
        complateLabel,
        complateNumber,
        info,
        templateId: 3
      }
    }
  }

  const onSearch = value => console.log(value)
  const onChangeTime = (value, dateString) => {
    // setDateTime(moment(dateString).format('YYYY-MM-DD HH:mm:00'))
    setDateTime(value)
  }
  const onOkTime = value => {
    // setDateTime(moment(value).format('YYYY-MM-DD HH:mm:00'))
    setDateTime(value)
  }
  return (
    <div className="tpl">
      <div className="tpl-operator">
        <div className="tpl-operator-left">
          <span className="center">
            {isDisabled ? actionName : ''}
            {/*{JSON.parse(window.sessionStorage.getItem('USER_INFO')).name}*/}
          </span>
          <DatePicker
            showTime
            allowClear={false}
            value={dateTime}
            disabled={isDisabled}
            format="YYYY-MM-DD HH:mm"
            onChange={onChangeTime}
            onOk={onOkTime}
          />
        </div>
        <div className="tpl-operator-right">
          <Select value={classify} disabled={isDisabled} onChange={e => classifyChange(e)}>
            {templateList.map(item => {
              return (
                <Option key={item.title} value={item.id}>
                  {item.title}
                </Option>
              )
            })}
          </Select>
          {!isDisabled && (
            <div style={{ display: 'inline-block', cursor: 'pointer' }} onClick={resetForm}>
              <i className="reset-icon" />
              {/* <img src={resetImg} width="22" height="16" /> */}
              <span className="reset">重置</span>
            </div>
          )}
        </div>
      </div>
      <div className="tpl-input">
        <Input
          placeholder="请输入"
          maxLength={20}
          style={{ width: 312 }}
          disabled={isDisabled}
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
      </div>
      <div className="tpl-fa" style={{ marginBottom: 16 }}>
        <div className="tpl-fa-name">头部</div>
        <Select
          value={headLabel}
          style={{ width: 86, marginRight: 16 }}
          disabled={isDisabled}
          onChange={e => setHeadLabel(e)}
        >
          {headOption.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
        <Input
          className="float-input"
          style={{ height: 32, marginRight: 8 }}
          disabled={isDisabled}
          value={headNumber}
          onChange={e => changeHeadNumber(e.target.value)}
          onBlur={e => formatNumber(e.target.value, 1)}
        />
        <div className="tpl-fa-unit">cm</div>
      </div>
      <div className="tpl-fa">
        <div className="tpl-fa-name">整体</div>
        <Select
          value={complateLabel}
          style={{ width: 86, marginRight: 16 }}
          disabled={isDisabled}
          onChange={e => setComplateLabel(e)}
        >
          {complateOption.map(item => {
            return (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            )
          })}
        </Select>
        <Input
          className="float-input"
          style={{ height: 32, marginRight: 8 }}
          disabled={isDisabled}
          value={complateNumber}
          onChange={e => changeComplateNumber(e.target.value)}
          onBlur={e => formatNumber(e.target.value, 2)}
        />
        <div className="tpl-fa-unit">mm</div>
      </div>
      <div className="tpl-line"></div>
      <div className="tpl-info">说明</div>
      <div className="tpl-textarea">
        <TextArea
          autoSize={{ minRows: 3, maxRows: 5 }}
          maxLength={200}
          style={{ width: 880 }}
          disabled={isDisabled}
          value={info}
          onChange={e => setInfo(e.target.value)}
        />
      </div>
      <div className="tpl-line"></div>
      {/* <div className="tpl-point">
        <div className="point">点位</div>
        {!isDisabled && (
          <Search placeholder="搜索增加点位" onSearch={onSearch} style={{ width: 264 }} />
        )}
        {isDisabled && <></>}
      </div> */}
    </div>
  )
}
ThirdTpl.defaultProps = {
  isDisabled: false
}
export default ThirdTpl
